import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

const EVENT_TYPE_OPTIONS = [
  'RECEIVING',
  'SHRINKAGE',
  'ADJUSTMENT',
  'CUSTOMER_ORDER',
  'RESERVATION',
  'INVENTORY_STATE_V2',
  'UNIT_OF_MEASURE_CHANGE',
  'SUBTASK_STATUS_CHANGE',
  'LOCATION_RECOMMENDATION_CHANGE',
  'EDITED_RECEIVING',
] as const;

export const warehouseCommonRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'warehouse-common',
  validateSearch: z.object({
    searchQuery: z.coerce.string().optional(),
    investigateItem: z.coerce.boolean().optional(),
    eventTypes: z.array(z.enum(EVENT_TYPE_OPTIONS)).optional().default([]),
    startDate: z.string().nullable(),
    endDate: z.string().nullable(),
    showItemInfoDrawer: z.coerce.boolean().optional(),
  }).parse,
});
